// Ephemeral state for the "quota exceeded" modal. The axios interceptor
// dispatches `quota/show` with the BE error body
// ({ code, resource, limit, current, message }) when any request rejects
// with `code: 'quota_exceeded'`.

export const state = {
    visible: false,
    payload: null,
};

export const mutations = {
    SHOW(state, payload) {
        state.payload = payload || null;
        state.visible = true;
    },
    HIDE(state) {
        state.visible = false;
        state.payload = null;
    },
};

export const actions = {
    show({commit}, payload) {
        commit('SHOW', payload);
    },
    hide({commit}) {
        commit('HIDE');
    },
};
